import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthHttpInterceptor } from './auth-http-interceptor';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth-guard';

import { UserIsDirective } from './user-is.directive';
import { UserCanDirective } from './user-can.directive';

@NgModule({
  imports: [
    HttpClientModule,
    HttpClientJsonpModule,
  ],
  declarations: [
    UserIsDirective,
    UserCanDirective,
  ],
  exports: [
    UserIsDirective,
    UserCanDirective,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ]
})
export class AuthModule {
  constructor() {}

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        AuthGuard,
        AuthService,
      ],
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts